<template>
  <ul>
    <li
      v-for="(val, feature) in features"
      :key="feature"
      class="feature"
    >
      <i class="icon">
        <component :is="featureIconComponent(feature)" />
      </i>
      <div class="text">
        {{ $t("objectDescription:" + feature, { count: val }) }}
      </div>
    </li>
  </ul>
</template>
<script>
import ActiveObjectStore from 'mixins/ActiveObjectStore';
import { mapGetters } from 'vuex';

/* ICONS */
import IconFaLightBuilding from 'ICON:IconBuilding';
import IconFaLightHome from 'ICON:IconHome';
import IconOwnResort from 'ICON:IconResort';
import IconOwnDishwasher from 'ICON:IconDishwasher';
import IconFaLightTv from 'ICON:IconTv';
import IconOwnTerraceBalcony from 'ICON:IconTerraceBalcony';
import IconFaLightWifi from 'ICON:IconWifi';
import IconFaLightParkingCircle from 'ICON:IconParkingCircle';
import IconFaLightRulerCombined from 'ICON:IconRulerCombined';
import IconFaLightUserPlus from 'ICON:IconUserPlus';
import IconFaLightUserFriends from 'ICON:IconUserFriends';
import IconFaLightShower from 'ICON:IconShower';
import IconFaLightBed from 'ICON:IconBed';
import IconFaLightWasher from 'ICON:IconWasher';
import IconFaLightDryer from 'ICON:IconDryer';
import IconFaLightDog from 'ICON:IconDog';
import IconOwnDogNo from 'ICON:IconDogNo';
import IconFaLightSmokingBan from 'ICON:IconSmokingBan';
import IconFaLightSnowflake from 'ICON:IconSnowflake';
import IconOwnBarbecue from 'ICON:IconBarbecue';
import IconFaLightFireAlt from 'ICON:IconFireAlt';
import IconFaLightFish from 'ICON:IconFish';
import IconNounproject2761404 from 'ICON:IconBoat';
import IconNounproject2635604 from 'ICON:IconSauna';
import IconOwnElevator from 'ICON:IconElevator';
import IconFaLightHotTub from 'ICON:IconHotTub';
import IconFaLightSwimmingPool from 'ICON:IconSwimmingPool';
import IconFaLightQuestionSquare from 'ICON:IconQuestionSquare';
import IconFaLightWater from 'ICON:IconWater';

export default {
  name: 'ObjectFeatures',
  components: {
    IconFaLightBuilding,
    IconFaLightHome,
    IconOwnResort,
    IconOwnDishwasher,
    IconFaLightTv,
    IconOwnTerraceBalcony,
    IconFaLightWifi,
    IconFaLightParkingCircle,
    IconFaLightRulerCombined,
    IconFaLightUserPlus,
    IconFaLightUserFriends,
    IconFaLightShower,
    IconFaLightBed,
    IconFaLightWasher,
    IconFaLightDryer,
    IconFaLightDog,
    IconOwnDogNo,
    IconFaLightSmokingBan,
    IconFaLightSnowflake,
    IconOwnBarbecue,
    IconFaLightFireAlt,
    IconFaLightFish,
    IconNounproject2761404,
    IconNounproject2635604,
    IconOwnElevator,
    IconFaLightHotTub,
    IconFaLightSwimmingPool,
    IconFaLightQuestionSquare,
    IconFaLightWater,
  },
  mixins: [ActiveObjectStore],
  props: {
    long: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      featureIcon: [
        // defined icon components for the given feature
        { feature: 'swimmingpool', icon: 'IconFaLightSwimmingPool' },
        { feature: 'apartment', icon: 'IconFaLightBuilding' },
        { feature: 'house', icon: 'IconFaLightHome' },
        { feature: 'dishwasher', icon: 'IconOwnDishwasher' },
        { feature: 'terrace', icon: 'IconOwnTerraceBalcony' },
        { feature: 'internet', icon: 'IconFaLightWifi' },
        { feature: 'parking', icon: 'IconFaLightParkingCircle' },
        { feature: 'squaremeters', icon: 'IconFaLightRulerCombined' },
        { feature: 'squaremeterLiving', icon: 'IconFaLightRulerCombined' },
        { feature: 'personsMax', icon: 'IconFaLightUserFriends' },
        { feature: 'bathroom', icon: 'IconFaLightShower' },
        { feature: 'countRoomsBath', icon: 'IconFaLightShower' },
        { feature: 'sleepingRoom', icon: 'IconFaLightBed' },
        { feature: 'countRoomsSleeping', icon: 'IconFaLightBed' },
        { feature: 'washingmachine', icon: 'IconFaLightWasher' },
        { feature: 'dryer', icon: 'IconFaLightDryer' },
        { feature: 'petsallowed', icon: 'IconFaLightDog' },
        { feature: 'petsnotallowed', icon: 'IconOwnDogNo' },
        { feature: 'nonsmoking', icon: 'IconFaLightSmokingBan' },
        { feature: 'airconditioning', icon: 'IconFaLightSnowflake' },
        { feature: 'grill', icon: 'IconOwnBarbecue' },
        { feature: 'fireplace', icon: 'IconFaLightFireAlt' },
        { feature: 'fishing', icon: 'IconFaLightFish' },
        { feature: 'boatrentalservice', icon: 'IconNounproject2761404' },
        { feature: 'whirlpool', icon: 'IconFaLightHotTub' },
        { feature: 'tv', icon: 'IconFaLightTv' },
        { feature: 'sauna', icon: 'IconNounproject2635604' },
        { feature: 'seaview', icon: 'IconFaLightWater' },
      ],
    };
  },
  computed: {
    ...mapGetters(['getObjectFeatures']),
    features() {
      const data = this.getObjectFeatures();
      // eslint-disable-next-line no-unused-vars
      let sourceMap = {};
      try {
        sourceMap = {
          [data.objectType]: data.objectType,
          squaremeterLiving: data.squaremeterLiving,
          countRoomsSleeping: data.countRoomsSleeping,
          countRoomsBath: data.countRoomsBath,
          personsMax: data.personsMax,
          petsallowed:
            data.detailPetAllowed > 0 ? data.detailPetAllowed : false,
          petsnotallowed: data.detailPetAllowed === 0,
          nonsmoking:
            (data.searchCriteria &&
              data.searchCriteria.indexOf('nonsmoking') > -1) ||
            false,
        };
      } catch (e) {
        // eslint-disable-next-line no-console
        console.log('Error in sourceMap', e);
      }
      const returnObject = {};
      try {
        // loop all desired features
        Object.keys(sourceMap).forEach((feature) => {
          if (sourceMap[feature] && Object.keys(returnObject).length < 6) {
            returnObject[feature] = sourceMap[feature];
          }
        });
      } catch (e) {
        // eslint-disable-next-line no-console
        console.log('Error in loop: all desired features', e);
      }
      // add all features
      if (this.long === true && data.searchCriteria) {
        Object.values(data.searchCriteria).forEach((feature) => {
          returnObject[feature] = 1;
        });
      }
      return returnObject;
    },
    loadedComponents() {
      // get all loaded components
      const loaded = [];
      const { components } = this.$options;
      Object.keys(components).forEach((key) => {
        loaded.push(key);
      });
      return loaded;
    },
  },
  methods: {
    componentExists(component) {
      // check if component exists (needed for icon components)
      return this.loadedComponents.indexOf(component) !== -1;
    },
    featureIconComponent(search) {
      // get feature icon component name
      const componentName = this.featureIcon.find(
        (icon) => icon.feature === search
      );
      if (
        typeof componentName !== 'undefined' &&
        componentName.icon !== '' &&
        this.componentExists(componentName.icon)
      ) {
        return componentName.icon;
      }
      // eslint-disable-next-line no-console
      console.log(`Error: Icon for feature ${search} missing`);
      return 'IconFaLightQuestionSquare'; // default icon ? for missing feature
    },
  },
};
</script>
